import React from 'react'
import clsx from 'clsx'

import * as Icon from '@makyoapp/makyo-icon/icon'
import { ListSelectOption, MultiIconSelect, SingleIconSelect } from '@makyoapp/makyo-ui'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useUpdateCompSettingValue } from '@/hooks/useUpdateCompSettings'
import { BuilderComponentSetting, FlattenedItem } from '@/shared/builder'

interface IconSelectFieldSettingProps {
  id: string
  settingId: string
  ancestors: FlattenedItem[]
  iconSelectSettings?: BuilderComponentSetting['iconSelectSettings']
  value: any
}

const IconSelectFieldSetting = ({
  iconSelectSettings,
  id,
  settingId,
  value,
  ancestors,
}: IconSelectFieldSettingProps) => {
  const { activeComponent } = useActiveLayerContext()
  const updateValue = useUpdateCompSettingValue(id)

  const isArr = Array.isArray(value)
  let isColor = false
  const rawOptions =
    // todo: limit iconSelectSettings into array only
    typeof iconSelectSettings?.options === 'function'
      ? iconSelectSettings.options(activeComponent?.id || '', ancestors)
      : iconSelectSettings?.options

  const iconOptions =
    rawOptions?.map((opt) => {
      let ic: ((selected: boolean) => React.ReactNode) | React.ReactNode = <></>
      if (opt.icon !== '') {
        const MaybeIc = Icon[opt.icon as keyof typeof Icon]
        ic = MaybeIc ? <MaybeIc /> : <img src={opt.icon} width={24} height={24} alt='' />
      }

      if (opt.color) {
        isColor = true
        ic = (active) => (
          <div
            className={clsx(
              'w-full h-full rounded-md',
              'border bdr transition-all',
              active && 'border-3 border-zinc-300 dark:border-slate-600'
            )}
            style={{
              background: opt.color,
            }}
          ></div>
        )
      }

      return {
        id: opt.id,
        icon: ic,
        title: opt.title,
      } as ListSelectOption
    }) ?? []

  return !iconSelectSettings?.multiple ? (
    <SingleIconSelect
      id={settingId}
      onClick={async (opt) => {
        await updateValue(opt.id)
      }}
      options={iconOptions}
      optionClassName={clsx(isColor && 'bg-transparent!')}
      selected={(value as string) ?? iconOptions[0]?.id}
    />
  ) : (
    <MultiIconSelect
      id={settingId}
      onChange={updateValue}
      options={iconOptions}
      optionClassName={clsx(isColor && 'bg-transparent!')}
      selected={!isArr ? [] : (value as string[])}
    />
  )
}

export default IconSelectFieldSetting
